import { Directive, ElementRef, forwardRef, HostListener, Input, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[nimbusMatTimeNumber][formControlName],[nimbusMatTimeNumber][formControl],[nimbusMatTimeNumber][ngModel]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MatTimeNumberDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class MatTimeNumberDirective implements ControlValueAccessor {
  private readonly VALID_SYMBOLS: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  private onControlChanged: (value: string) => void;

  @Input() public lengthLimit: number = 2;

  @Input() public maxValue: number | null = null;

  @Input() public minValue: number | null = null;

  public constructor(
    private elementRef: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
  ) {}

  public registerOnChange(fn: (value: string) => void): void {
    this.onControlChanged = fn;
  }

  public registerOnTouched(fn: () => {}): void {}

  public registerOnValidatorChange(fn: () => void): void {}

  @HostListener('input', ['$event'])
  public onInput(event: KeyboardEvent): void {
    const inputValue: string = (event.target as HTMLInputElement).value;
    this.parseInputValue(inputValue.substr(0, this.lengthLimit));
  }

  private parseInputValue(inputValue: string): void {
    let result: string = inputValue;
    let wasClamped = false;
    for (const symbol of inputValue) {
      if (this.VALID_SYMBOLS.indexOf(symbol) < 0) {
        result = result.replace(symbol, '');
      }
    }

    if (this.maxValue && this.maxValue < parseInt(result, 0)) {
      result = `${this.maxValue}`;
      wasClamped = true;
    }

    if (this.minValue && this.minValue > parseInt(result, 0)) {
      result = `${this.minValue}`;
      wasClamped = true;
    }

    this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-invalid', wasClamped ? 'true' : 'false');

    if (this.onControlChanged) {
      this.onControlChanged(result);
    }
    this.elementRef.nativeElement.value = result;
  }

  public writeValue(value: string): void {
    const inputValue: string = value;
    this.elementRef.nativeElement.value = inputValue;
  }
}
